// ONYX-CUSTOM: terms acceptance flow before checkout, and the cart drawer's optional "continue shopping" button
// The drawer footer is replaced on every cart change, so the dismiss button is handled by one listener on the document.
document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-onyx-close-cart]')) return;
  document.querySelector('cart-drawer')?.hide();
});

class TermsAgreement extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();

    const formId = this.dataset.termsFormId;
    this.form = formId ? document.getElementById(formId) : this.querySelector('[data-terms-checkout-form]');
    this.dialog = this.querySelector('[data-terms-dialog]');
    this.checkbox = this.querySelector('[data-terms-checkbox]');
    this.acceptButton = this.querySelector('[data-terms-accept]');
    this.checkoutButton = this.querySelector('[data-terms-checkout-button]');

    if (!this.checkbox) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    if (this.form && this.dialog && this.acceptButton) {
      // Drawer flow: intercept the checkout submit and confirm terms in a dialog.
      this.form.addEventListener('submit', this.handleSubmit.bind(this), { signal });
      this.acceptButton.addEventListener('click', this.handleAccept.bind(this), { signal });
      this.dialog.addEventListener('modal:handleAfterHide', this.restoreDrawerFocus.bind(this), { signal });
      document.addEventListener('keyup', this.handleEscape.bind(this), { capture: true, signal });
    } else if (this.checkoutButton) {
      // Page flow: no dialog -- simply gate the checkout button on the checkbox.
      this.checkbox.addEventListener('change', this.syncCheckoutButton.bind(this), { signal });
    }

    window.addEventListener('pageshow', this.reset.bind(this), { signal });

    this.reset();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  reset() {
    this.isContinuing = false;
    this.submitter = null;

    if (this.checkbox) this.checkbox.checked = false;
    if (this.acceptButton) this.acceptButton.disabled = false;
    this.syncCheckoutButton();
  }

  syncCheckoutButton() {
    if (this.checkoutButton) this.checkoutButton.disabled = !this.checkbox.checked;
  }

  handleSubmit(event) {
    const submitter =
      event.submitter ||
      (this.dataset.termsFormId ? null : this.form.querySelector('[name="checkout"]'));

    if (submitter?.name !== 'checkout' || this.isContinuing) return;
    if (this.checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.submitter = submitter;
    this.dialog.show(this.submitter);
  }

  handleAccept() {
    if (this.isContinuing) return;

    this.isContinuing = true;
    this.acceptButton.disabled = true;
    this.checkbox.checked = true;
    this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    this.dialog.hide().then(() => {
      if (this.submitter) this.form.requestSubmit(this.submitter);
    });
  }

  handleEscape(event) {
    if (event.code !== 'Escape' || !this.dialog.open) return;

    // Keep the Escape intended for this nested dialog from also closing the cart drawer.
    event.preventDefault();
    event.stopImmediatePropagation();
    this.dialog.hide();
  }

  restoreDrawerFocus() {
    const drawer = this.closest('cart-drawer');
    if (!drawer?.open || !this.submitter) return;

    // ModalComponent clears its focus trap asynchronously; restore the parent drawer's trap after it does.
    setTimeout(() => FoxTheme.a11y.trapFocus(drawer, this.submitter));
  }
}

if (!customElements.get('terms-agreement')) {
  customElements.define('terms-agreement', TermsAgreement);
}
